<template>
  <el-dialog title="发布动态" :visible.sync="visible"  width="44%" :before-close="handleClose" :append-to-body="true">
    <el-form :rules="rules" ref="ruleForm"  label-width="auto"
             :model="form" class="form-box">
      <el-form-item label="内容：" prop="content" label-width="120px" class="form-item">
<!--        <el-input class="form-content" type="textarea" :autosize="{ minRows: 6 }" placeholder="请输入说说内容"
                  v-model="form.content">
        </el-input>-->
        <div class="contentInputBox" ref="contentInputBox">
          <div class="">
            <div ref="textareaRef" contenteditable="true" @input="onInput"
                 @paste="optimizePasteEvent" :data-placeholder="placeholder"
                 class="comment-textarea" v-html="$emo.transform(form.content)"></div>
            <span class="point biaoqing-point" @click="showEmoji = !showEmoji">
                <i class="icon iconfont icon-biaoqing"></i>
            </span>
          </div>
          <div class="emoji-wrapper" v-if="showEmoji">
            <Emoji @chooseEmoji="handleChooseEmoji"/>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="可见范围：" prop="scope" label-width="120px" class="form-item" v-if="category==='private'">
        <el-select v-model="form.scope" placeholder="请选择">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="群空间可见：" prop="groupVisible" label-width="120px" class="form-item" v-if="category==='private'">
        <div style="display: flex">
          <el-switch
              style="display: block"
              v-model="form.groupVisible"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              @change="groupVisibleChange">
          </el-switch>
          <div class="tips">
            <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="群空间可见需要将可见范围设置成【公开】，并且加入的所有群聊可见">
              <div class="el-icon-question" slot="reference"></div>
            </el-popover>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="星空间可见：" prop="characterVisible" label-width="120px" class="form-item" v-if="category==='private'">
        <div style="display: flex">
          <el-switch
              style="display: block"
              v-model="form.characterVisible"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              @change="characterVisibleChange">
          </el-switch>
          <div class="tips">
            <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="星空间可见需要将可见范围设置成【公开】, 角色信息需要选择绑定的模板角色">
              <div class="el-icon-question" slot="reference"></div>
            </el-popover>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="地区空间可见：" prop="regionVisible" label-width="120px" class="form-item" v-if="category==='private'">
        <div style="display: flex">
          <el-switch
              style="display: block"
              v-model="form.regionVisible"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              @change="regionVisibleChange">
          </el-switch>
          <div class="tips">
            <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="地区空间可见需要将可见范围设置成【公开】，并且所有常驻的地区群聊可见">
              <div class="el-icon-question" slot="reference"></div>
            </el-popover>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="角色选择：" prop="character" label-width="120px" class="form-item" v-if="!groupTemplateId">
        <span class="character-item" v-on:click="openCharacterChooseDialog">
          <el-avatar :fit="fit" size="medium" icon="el-icon-user-solid" :src="form.avatar">
          </el-avatar>
        </span>
        <span class="nick-name">{{form.nickName}} <el-button @click="removeCharacter" class="del-btn" v-if="form.characterId && category!=='character'" type="danger" icon="el-icon-delete" size="mini" circle></el-button></span>
      </el-form-item>
      <el-form-item label="我的角色：" prop="myCharacters" label-width="120px" class="form-item" v-if="(category==='character' || category ==='private') && !characterId && !groupTemplateId">
        <div class="my-characters" style="display: flex;align-items: center;gap: 10px;">
          <el-select v-model="selectValue" placeholder="请选择" @change="selectMyCharacterChange">
            <el-option
                v-for="item in myCharacters"
                :key="item.characterId"
                :label="item.characterName"
                :value="item.characterId">
              <span style="float: left">{{ item.characterName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px"><head-image :name="item.characterName" :url="item.characterAvatar" :size="30"></head-image></span>
            </el-option>
          </el-select>
          <el-select v-model="selectAvatarValue" placeholder="请选择" @change="selectMyCharacterAvatarChange">
            <el-option
                v-for="item in selectAvatars"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px"><head-image :name="item.name" :url="item.avatar" :size="30"></head-image></span>
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="图片|视频|音频：" prop="imgUrl" label-width="120px" class="form-item">
<!--        <batch-image-upload class="form-content"
                            :action="imageAction"
                            :showLoading="true"
                            :maxSize="maxSize"
                            :fileTypes="['image/jpeg', 'image/png', 'image/jpg','image/webp', 'image/gif']"
                            :imageList="imageList"
                            @success="handleUploadImageSuccess"
                            @remove="handleRemove"
                            @change="handleChange"
                            ref="imageUploader">
        </batch-image-upload>-->
        <multi-media-upload :file-list="fileList" :limit="9" :file-size="10" :multiple="true" @update:fileList="updateFileList"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('ruleForm')" size="small">发布</el-button>
      <el-button @click="resetForm('ruleForm')" size="small">清空</el-button>
    </span>
    <TemplateCharacterChoose
        :append-to-body="true"
        ref="templateCharacterChoose"
        :visible="chooseCharacterDialogVisible"
        @close="closeChooseCharacterDialog"
        @confirm="handleOk">
    </TemplateCharacterChoose>
    <el-dialog
        width="30%"
        title="角色头像"
        :append-to-body="true"
        :visible.sync="selectCharacterAvatarVisible"
        :before-close="closeSelectCharacterAvatar">
      <el-scrollbar style="height:400px;">
        <div v-for="(characterAvatar, index) in characterAvatars" :key="index" style="display: flex;justify-content: space-between;align-items: center;">
          <character-avatar-item class="character-avatar-item-left" :characterAvatar="characterAvatar"></character-avatar-item>
          <div class="character-avatar-item-right">
            <el-button :type="avatarActiveIndex === index ? 'success' : ''"
                       icon="el-icon-check"
                       circle
                       @click="chooseCharacterAvatar(characterAvatar, index)"></el-button>
          </div>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
          <el-button @click="closeSelectCharacterAvatar" size="small">取 消</el-button>
          <el-button type="primary" @click="chooseCharacterAvatarOk" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import BatchFileUpload from "@/components/common/BatchFileUpload";
import BatchImageUpload from "@/components/common/BatchImageUpload";
import HeadImage from "@/components/common/HeadImage";
import TemplateGroupItem from "@/components/group/TemplateGroupItem";
import TemplateCharacterItem from "@/components/group/TemplateCharacterItem";
import Emoji from '@/components/emoji';
import MultiMediaUpload from "@/components/common/MultiMediaUpload";
import TemplateCharacterChoose  from "../template/TemplateCharacterChoose.vue";
import CharacterAvatarItem from "@/components/group/CharacterAvatarItem";

export default {
  name: "AddTalk",
  components: {
    HeadImage,
    BatchFileUpload,
    BatchImageUpload,
    TemplateGroupItem,
    TemplateCharacterItem,
    Emoji,
    MultiMediaUpload,
    TemplateCharacterChoose,
    CharacterAvatarItem,
  },
  props: {
    visible: {
      type: Boolean
    },
    talkId: {
      type: Number,
      default: null
    },
    category: {
      type: String,
      required: true
    },
    groupId: {
      type: Number,
    },
    regionGroupId: {
      type: Number,
    },
    regionCode: {
      type: String,
    },
    characterId: {
      type: Number,
      default: null
    },
    groupTemplateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      fit: 'fill',
      maxSize: 5 * 1024 * 1024,
      imageList: [],
      uploadHeaders: {"accessToken":sessionStorage.getItem('accessToken')},
      fileTypes: ['image/jpeg', 'image/png', 'image/jpg','image/webp', 'image/gif'],
      rules: {
        scope: [
          { required: true, message: '请选择公开范围', trigger: 'blue' }
        ],
      },
      form: {
        id: null,
        content: '',
        scope: 9,
        anonymous: false,
        nickName: '',
        avatar: '',
        characterId: null,
        avatarId: null,
        enableCharacterChoose: true,
        groupVisible: false,
        regionVisible: false,
        characterVisible: false,
        files: []
      },
      fileList: [],
      options: [
        {value: 1, label: "私密"},
        {value: 2, label: "好友可见"},
        {value: 9, label: "公开"}
      ],
      chooseCharacterDialogVisible: false,
      searchText: "",
      characterSearchText: "",
      templateGroupList: [],
      templateCharacterList: [],
      groupActiveIndex: -1,
      characterActiveIndex: -1,
      templateCharacter: {},
      placeholder: "请输入内容",
      lastEditRange: null,
      showEmoji: false,
      fileUploadLoading: null,
      avatarActiveIndex: -1,
      characterAvatars: [],
      selectCharacterAvatarVisible: false,
      newCharacterAvatar: {},
      character: {},
      myCharacters: [],
      selectValue: '',
      selectAvatarValue: '',
      selectAvatars: [],
    }
  },
  created() {
    if (this.talkId !== null) {
      this.getTalkDetail(this.talkId);
    }
    if (this.characterId) {
      this.getCharacterDetail();
    }
    if ((this.category === "private" || this.category === "character") && !this.characterId && !this.groupTemplateId) {
      this.queryMyCharacters();
    }
  },
  methods: {
    onInput(e) {
      let selection = window.getSelection()
      this.lastEditRange = selection.getRangeAt(0);
    },
    optimizePasteEvent(e) {
      // 监听粘贴内容到输入框事件，对内容进行处理 处理掉复制的样式标签，只拿取文本部分
      e.stopPropagation()
      e.preventDefault()
      let text = '', event = (e.originalEvent || e)
      if (event.clipboardData && event.clipboardData.getData) {
        text = event.clipboardData.getData('text/plain')
      } else if (window.clipboardData && window.clipboardData.getData) {
        text = window.clipboardData.getData('text')
      }
      if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, text)
      } else {
        document.execCommand('paste', false, text)
      }
    },
    //添加表情
    handleChooseEmoji(emoText) {
      // 创建一个img标签（表情）
      let img = document.createElement('img');
      img.src = this.$emo.textToUrl(emoText);
      img.style.verticalAlign = 'middle';
      img.style.marginLeft = "2px"
      img.style.marginRight = "2px"
      img.style.height = "25px"
      img.style.width = "25px"
      img.dataset.code = emoText;

      let edit = this.$refs.textareaRef;
      edit.focus()
      let selection = window.getSelection()
      // 如果存在最后的光标对象
      if (this.lastEditRange) {
        // 选区对象清除所有光标
        selection.removeAllRanges();
        // 并添加最后记录的光标，以还原之前的状态
        selection.addRange(this.lastEditRange);
        // 获取到最后选择的位置
        let range = selection.getRangeAt(0);
        // 在此位置插入表情图
        range.insertNode(img)
        // false，表示将Range对象所代表的区域的起点移动到终点处
        range.collapse(false)

        // 记录最后的位置
        this.lastEditRange = selection.getRangeAt(0);
      } else {
        // 将表情添加到可编辑的div中，作为可编辑div的子节点
        edit.appendChild(img)
        // 使用选取对象，选取可编辑div中的所有子节点
        selection.selectAllChildren(edit)
        // 合并到最后面，即实现了添加一个表情后，把光标移到最后面
        selection.collapseToEnd()
      }
      this.showEmoji = false
    },
    createSendText() {
      let sendText = ""
      this.$refs.textareaRef.childNodes.forEach((node) => {
        if (node.nodeName == "#text") {
          sendText += this.html2Escape(node.textContent);
        } else if (node.nodeName == "SPAN") {
          sendText += node.innerText;
        } else if (node.nodeName == "IMG") {
          sendText += node.dataset.code;
        } else if (node.nodeName == "DIV") {
          sendText += '\n';
          node.childNodes.forEach((divNode) => {
            if (divNode.nodeName == "#text") {
              sendText += this.html2Escape(divNode.textContent);
            } else if (divNode.nodeName == "IMG") {
              sendText += divNode.dataset.code;
            } else if (divNode.nodeName == "SPAN") {
              sendText += divNode.innerText;
            }
          })
        }
      })
      return sendText;
    },
    html2Escape(strHtml) {
      return strHtml.replace(/[<>&"]/g, function (c) {
        return {
          '<': '&lt;',
          '>': '&gt;',
          '&': '&amp;',
          '"': '&quot;'
        }[c];
      });
    },
    handleClose() {
      this.$emit("close");
    },
    clearFiles () {
      //this.$refs.imageUploader.clearImages();
      //this.$refs.imageUploader.$emit("removeImages")
      this.fileList = [];
    },
    handleChange(info, fileList) {
      this.imageList = fileList;
    },
    handleUploadImageSuccess(data) {
      this.imageList.push({ url: data.originUrl});
    },
    handleRemove(file) {
      this.imageList.forEach((item, index) => {
        if (item.url === file.url) {
          this.imageList.splice(index, 1);
        }
      });
    },
    updateFileList(fileList) {
      this.fileList = fileList;
    },
    async submitForm(formName) {
      let talkParam = this.form;
      talkParam.category = this.category;
      talkParam.groupId = this.groupId;
      talkParam.regionGroupId = this.regionGroupId;
      talkParam.regionCode = this.regionCode;
      talkParam.groupTemplateId = this.groupTemplateId;
      //talkParam.imgUrls = this.imageList.map(obj => {return obj.url});
      let el = this.$refs.textareaRef;
      if (!el.innerHTML) {
        this.$message.warning("请输入动态内容");
        return
      }
      let sendText = this.createSendText();
      if (!sendText.trim()) {
        return
      }
      talkParam.content = sendText;
      talkParam.files = [];
      if (this.fileList.length > 0) {
        if (this.fileList.length > 9) {
          this.$message.warning("最多只能上传9个文件");
          return;
        }
        const values = this.fileList.map(obj => obj.fileType);
        if (new Set(values).size > 1) {
          this.$message.warning("不能同时上传多种类型文件");
          return;
        }
        if (this.fileList.filter(item => item.fileType ===  2).length > 1) {
          this.$message.warning("只能上传一个视频文件");
          return;
        }
        if (this.fileList.filter(item => item.fileType ===  3).length > 1) {
          this.$message.warning("只能上传一个音频文件");
          return;
        }

        this.loading = this.$loading({
          lock: true,
          text: '正在上传文件...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url.startsWith("blob:")) {
          let obj = await this.uploadFile(this.fileList[i]);
          if (obj == null) {
            this.loading && this.loading.close();
            return;
          }
          talkParam.files.push(obj);
        } else {
          talkParam.files.push(this.fileList[i]);
        }
      }
      this.loading && this.loading.close();

      //console.log("talkParam", talkParam);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = "/talk"
          if (talkParam.id != null) {
            url += "/update"
          } else {
            url += "/add"
          }
          this.$http({
            url: url,
            method: 'post',
            data: talkParam
          }).then((data) => {
            this.$message.success("发布成功");
            this.resetForm('ruleForm');
            this.clearFiles();
            this.$emit("refresh");
          }).finally(() => {
            this.$emit("close");
          })
        }
      });
    },
    async uploadFile(file) {
      return new Promise((resolve, reject) => {
        let result = null;
        let formData = new FormData()
        let url = '';
        if (file.fileType === 1) {
          url = this.imageAction;
        } else if (file.fileType === 2) {
          url = this.videoAction;
        } else if (file.fileType === 3){
          url = this.audioAction;
        }
        formData.append('file', file.raw)
        this.$http({
          url: url,
          data: formData,
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((data) => {
          result = {fileType: file.fileType, url: null}
          let fileUrl = '';
          if (file.fileType === 1) {
            fileUrl = data.originUrl;
          } else if (file.fileType === 2) {
            fileUrl = data.videoUrl;
            result.coverUrl = data.coverUrl;
          } else if (file.fileType === 3) {
            fileUrl = data.url;
            result.name = data.originalName;
          } else {
            fileUrl = data;
          }
          result.url = fileUrl;
        }).catch((e) => {
          this.$message.warning('上传文件异常！');
        }).finally(() => {
          resolve(result)
        })
      });

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.avatar = '';
      this.form.nickName = '';
      this.fileList = [];
    },
    openCharacterChooseDialog() {
      if (this.characterId) {
        this.selectCharacterAvatarVisible = true;
      } else {
        this.chooseCharacterDialogVisible = true;
        this.queryTemplateGroup();
      }
    },
    closeChooseCharacterDialog() {
      this.chooseCharacterDialogVisible = false;
      this.templateGroupList = [];
      this.templateCharacterList = [];
      this.groupActiveIndex = -1;
      this.characterActiveIndex = -1;
    },
    queryTemplateGroup(){
      this.templateGroupList = []
      this.$http({
        url: "/templateGroup/list",
        method: 'get',
        params: ''
      }).then(data => {
        this.templateGroupList = data;
      })
    },
    queryTemplateCharacter(templateGroup, index) {
      this.groupActiveIndex = index;
      this.characterActiveIndex = -1;
      this.$http({
        url: `/templateCharacter/list/${templateGroup["id"]}`,
        method: 'get'
      }).then((data) => {
        this.templateCharacterList = data;
      });
    },
    chooseTemplateCharacter(templateCharacter, index) {
      this.characterActiveIndex = index;
      this.templateCharacter = templateCharacter;
    },
    handleOk(data) {
      console.log("handleOk", data);
      if (data?.characterAvatar?.id) {
        this.form.avatarId = data.characterAvatar.id;
        this.form.nickName = data.characterAvatar.level === 0 ? data.templateCharacter.name : data.characterAvatar.name;
        this.form.avatar = data.characterAvatar.avatar;
        this.form.characterId = data.templateCharacter.id;
      } else {
        this.form.nickName = data.templateCharacter.name;
        this.form.avatar = data.templateCharacter.avatar;
        this.form.characterId = data.templateCharacter.id;
        this.form.avatarId = null;
      }

      this.closeChooseCharacterDialog();
    },
    removeCharacter() {
      this.form.avatar = '';
      this.form.nickName = '';
      this.form.characterId = null;
    },
    selectMyCharacterChange(value) {
      let character = this.myCharacters.find(item => item.characterId === value)
      this.form.nickName = character.characterName;
      this.form.avatar = character.characterAvatar;
      this.form.characterId = character.characterId;
      this.form.avatarId = null;
      this.selectAvatarValue = '';
      this.selectAvatars = character.characterAvatars;
    },
    selectMyCharacterAvatarChange(value) {
      let obj = this.selectAvatars.find(item => item.id === value)
      this.form.avatar = obj.avatar;
      this.form.avatarId = obj.id;
      this.form.nickName = obj.level === 0 ? obj.templateCharacterName : obj.name;
    },
    getTalkDetail(talkId) {
      let _this = this
      this.$http({
        url: `/talk/getTalkDetail/${talkId}`,
        method: 'get'
      }).then((data) => {
        _this.form = data;
        _this.fileList = data.fileList || [];
        if (data.imgUrls && data.imgUrls.length > 0) {
          _this.imageList = data.imgUrls.map(item => {return {url: item}});
        }
      });
    },
    groupVisibleChange(value) {
      this.form.groupVisible = value;
    },
    regionVisibleChange(value) {
      this.form.regionVisible = value;
    },
    characterVisibleChange(value) {
      this.form.characterVisible = value;
    },
    getCharacterDetail() {
      this.$http({
        url: `/templateCharacter/findByCharacterId?id=${this.characterId}`,
        method: 'get'
      }).then((data) => {
        this.character = data;
        this.form.characterId = data.id;
        this.form.avatar = data.avatar;
        this.form.nickName = data.name;
        this.characterAvatars = data.characterAvatarVOList;
      });
    },
    closeSelectCharacterAvatar() {
      this.avatarActiveIndex = -1;
      this.selectCharacterAvatarVisible = false;
    },
    chooseCharacterAvatar(characterAvatar, index) {
      this.newCharacterAvatar = characterAvatar;
      this.avatarActiveIndex = index;
    },
    chooseCharacterAvatarOk() {
      this.form.avatarId = this.newCharacterAvatar.id;
      this.form.nickName = this.newCharacterAvatar.level === 0 ? this.character.name : this.newCharacterAvatar.name;
      this.form.avatar = this.newCharacterAvatar.avatar;
      this.closeSelectCharacterAvatar();
    },
    queryMyCharacters() {
      this.$http({
        url: "/characterUser/getMyCharacters",
        method: 'get'
      }).then((data) => {
        this.myCharacters = data;
      });
    },
  },
  computed: {
    imageAction() {
      return `/image/upload`;
    },
    videoAction() {
      return `/video/upload`;
    },
    audioAction() {
      return `/audio/upload`;
    },
    fileAction() {
      return `/file/upload`;
    }
  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.form-box {
  .form-item {
    .el-form-item__content {
      text-align: left;
    }

    .contentInputBox {
      width: 100%;
      border: 1px solid #67C23A;
      border-radius: 5px;
      background-color: #fff;
      position: relative;
      min-height: 100px;
      display: block;

      .comment-textarea {
        text-align: left;
        min-height: 100px;
        outline: none;
        padding-left: 10px;
        padding-top: 5px;
        white-space: pre-wrap;

        &:empty:before {
          content: attr(data-placeholder);
          color: #666;
        }
      }

      .biaoqing-point {
        cursor: pointer;
        display: inline-block;
        position: absolute;
        right: 5px;
        bottom: 0;

        i {
          font-size: 1.3rem;
          color: #67C23A;
        }
      }
    }
  }

  .character-item, nick-name {
    display: inline-block;
    height: 36px;
    line-height: 36px;
    vertical-align:middle;
    margin-right: 10px;
  }

  .nick-name {
    .del-btn {
      margin-left: 30px;
    }
  }

  .tips {
    margin-left: 10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}

.agm-container {
  display: flex;

  .agm-l-box {
    flex: 1;
    border: var(--border-color) solid 1px;
    box-sizing: content-box;

    .template-group-box {
      width: 100%;

      .group-item-left {
        float: left;
      }
      .group-item-right {
        float: right;
        margin-right: 10px;
        height: 65px;
        line-height: 65px;
      }
    }
  }

  .agm-r-box {
    flex: 1;
    border: var(--border-color) solid 1px;

    .template-character-box {
      width: 100%;

      .character-item-left {
        float: left;
      }
      .character-item-right {
        float: right;
        margin-right: 10px;
        height: 65px;
        line-height: 65px;
      }
    }
  }
}

.character-avatar-item-left {
  flex: 1;
}

.character-avatar-item-right {
  margin-right: 10px;
  height: 65px;
  line-height: 65px;
}

</style>